import { apiSlice } from "../api/apiSlice";

export const assignmentsApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getAssignments: builder.query({
      query: () => `/assignments`,
    }),
    getAssignment: builder.query({
      query: (id) => `/assignments/${id}`,
    }),
    addAssignment: builder.mutation({
      query: ({ data }) => ({
        url: "/assignments",
        method: "POST",
        body: data,
      }),
      async onQueryStarted(arg, { queryFulfilled, dispatch }) {
        try {
          const assignment = await queryFulfilled;

          if (assignment?.data?.id) {
            dispatch(
              apiSlice.util.updateQueryData(
                "getAssignments",
                undefined,
                (draft) => {
                  // Update the relevant task in the tasks array
                  draft.push(assignment?.data);

                  return draft;
                }
              )
            );
          }
        } catch {}
      },
    }),
    editAssignment: builder.mutation({
      query: ({ id, data }) => ({
        url: `/assignments/${id}`,
        method: "PATCH",
        body: data,
      }),
      async onQueryStarted(arg, { queryFulfilled, dispatch }) {
        try {
          const assignment = await queryFulfilled;

          if (assignment?.data?.id) {
            dispatch(
              apiSlice.util.updateQueryData(
                "getAssignments",
                undefined,
                (draft) => {
                  // Update the relevant task in the tasks array
                  const assignmentIndex = JSON.stringify(
                    // eslint-disable-next-line
                    draft.findIndex((assignment) => assignment.id == arg?.id)
                  );

                  Object.assign(draft[assignmentIndex], assignment?.data);

                  return draft;
                }
              )
            );
          }
        } catch {}
      },
    }),
    deleteAssignment: builder.mutation({
      query: (id) => ({
        url: `/assignments/${id}`,
        method: "DELETE",
      }),
      async onQueryStarted(arg, { queryFulfilled, dispatch }) {
        // optimistic cache update start
        const pathResult = dispatch(
          apiSlice.util.updateQueryData(
            "getAssignments",
            undefined,
            (draft) => {
              // Update the relevant task in the tasks array
              // eslint-disable-next-line
              const assignmentIndex = JSON.stringify(
                // eslint-disable-next-line
                draft.findIndex((assignment) => assignment.id == arg)
              );

              // eslint-disable-next-line
              return draft.filter((assignment) => assignment.id != arg);
            }
          )
        );
        // optimistic cache update end
        try {
          await queryFulfilled;
        } catch {
          pathResult.undo();
        }
      },
    }),
  }),
});

export const {
  useGetAssignmentQuery,
  useGetAssignmentsQuery,
  useGetAssignmentsMarkQuery,
  useAddAssignmentMutation,
  useEditAssignmentMutation,
  useDeleteAssignmentMutation,
} = assignmentsApi;
